var installedModules = {};
__webpack_require__.consumesLoadingData.moduleIdToConsumeDataMapping = {
	35202: {
		fallback: function() { return function() { return __webpack_require__(95093); }; },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "2.31.0",
		strictVersion: false,
		eager: true,
		layer: undefined,
		shareKey: "moment",

	},
	3155: {
		fallback: function() { return __webpack_require__.e(6540).then(function() { return function() { return __webpack_require__(96540); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react",

	},
	77938: {
		fallback: function() { return __webpack_require__.e(2165).then(function() { return function() { return __webpack_require__(32165); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/cdn",

	},
	62508: {
		fallback: function() { return __webpack_require__.e(7435).then(function() { return function() { return __webpack_require__(77435); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/currency",

	},
	59955: {
		fallback: function() { return __webpack_require__.e(2635).then(function() { return function() { return __webpack_require__(72635); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "25.3.2",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "i18next",

	},
	80103: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(40961); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "18.2.0",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-dom",

	},
	77037: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(49785); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "7.43.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-hook-form",

	},
	34477: {
		fallback: function() { return __webpack_require__.e(8096).then(function() { return function() { return __webpack_require__(32389); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "15.6.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "react-i18next",

	},
	38826: {
		fallback: function() { return __webpack_require__.e(3860).then(function() { return function() { return __webpack_require__(63860); }; }); },
		shareScope: ["default"],
		singleton: true,
		requiredVersion: "0.9.1",
		strictVersion: false,
		eager: false,
		layer: undefined,
		shareKey: "@qikserve/utils/emitter",

	}
};
var moduleToHandlerMapping = {};
__webpack_require__.consumesLoadingData.initialConsumes = [35202];
__webpack_require__.federation.installInitialConsumes = function(options) { return __webpack_require__.federation.bundlerRuntime.installInitialConsumes({
	initialConsumes: __webpack_require__.consumesLoadingData.initialConsumes,
	installedModules:installedModules,
	moduleToHandlerMapping,
	webpackRequire: __webpack_require__,
	asyncLoad: typeof options==='object' ? options.asyncLoad : undefined,
}); }
__webpack_require__.consumesLoadingData.chunkMapping = {
	"3155": [
		3155
	],
	"4121": [
		35202
	],
	"5898": [
		62508,
		59955,
		80103,
		77037,
		34477
	],
	"7938": [
		77938
	],
	"8826": [
		38826
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	__webpack_require__.federation.bundlerRuntime.consumes({
	chunkMapping: __webpack_require__.consumesLoadingData.chunkMapping,
	installedModules: installedModules,
	chunkId: chunkId,
	moduleToHandlerMapping,
	promises: promises,
	webpackRequire:__webpack_require__
	});
}